import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
  LabelList,
} from "recharts";
import { sortDescByValue, toNumber } from "../utils/chartTransforms";

const RankingDefeitosChart = ({ data = [], height = 300 }) => {
  const ordered = sortDescByValue(
    data.map((d) => ({ ...d, value: toNumber(d.value) }))
  );

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart
        data={ordered}
        layout="vertical"
        margin={{ top: 10, right: 30, left: 120, bottom: 10 }}
      >
        <defs>
          <linearGradient id="defeitoGradient" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#ff9f43" stopOpacity={0.9} />
            <stop offset="100%" stopColor="#e74c3c" stopOpacity={0.9} />
          </linearGradient>
        </defs>

        <CartesianGrid strokeDasharray="3 3" />
        <XAxis type="number" />
        <YAxis
          type="category"
          dataKey="name"
          width={180}
          tick={{ fontSize: 11 }}
        />

        <Tooltip
          formatter={(val, _, entry) => [
            `${val} ocorrências`,
            `Tipo de Embalagem: ${entry.payload.tipo_embalagem || "N/A"}`,
          ]}
          labelFormatter={(label) => `Defeito: ${label}`}
          contentStyle={{
            fontSize: 12,
            borderRadius: 8,
            backgroundColor: "#ffffffdd",
            border: "1px solid #ddd",
          }}
        />

        <Bar
          dataKey="value"
          fill="url(#defeitoGradient)"
          radius={[0, 5, 5, 0]}
          name="Qtd. de NCEs"
        >
          <LabelList
            dataKey="value"
            position="right"
            fill="#333"
            fontSize={11}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default RankingDefeitosChart;
